import { Button, Dialog, DialogBody, DialogFooter } from '@blueprintjs/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  closeLayerManager,
  selectLayerManager,
} from 'uf/projects/layerManagerSlice';

import { dialogClasses, Sizes } from 'uf/ui/base/sizes';
import LayerManager from 'uf/ui/layers/LayerManager/LayerManager';

export default function LayerManagerDialog() {
  const dispatch = useDispatch();
  const { isOpen } = useSelector(selectLayerManager);

  const handleClose = () => {
    dispatch(closeLayerManager());
  };

  return (
    <Dialog
      className={dialogClasses[Sizes.XLARGE]}
      isOpen={isOpen}
      onClose={handleClose}
      title="Layer Manager"
      isCloseButtonShown={false}>
      <DialogBody>
        <LayerManager />
      </DialogBody>
      <DialogFooter
        minimal
        actions={
          <Button intent="primary" onClick={handleClose}>
            Close
          </Button>
        }
      />
    </Dialog>
  );
}
